<template>
	<CRow class="content-center" style="text-align:left;">
		<CCol sm="9">
			<CAlert :color="color">
				<CRow>
					<CCol v-if="typeof errorMessage !== 'string'">
						<div
							v-for="(value, key, index) in errorMessage"
							:key="`${key}-${index}`"
						>
							<!-- <span>{{value}}</span> -->
							<div v-for="item in value" :key="item.id">
								<span
									><b>{{ item }}</b></span
								><br />
							</div>
						</div>
						<br />
					</CCol>
					<CCol v-else>
						<span
							><b>{{ errorMessage }}</b></span
						><br /><br />
					</CCol>
				</CRow>
			</CAlert>
		</CCol>
	</CRow>
</template>

<script>
	export default {
		name: 'errorAlert',
		props: {
			color: {
				type: String,
				default: 'danger',
			},
			errorMessage: {
				type: [String, Array, Object],
				default: 'Ocurrio un error',
			},
		},
	};
</script>

<style></style>
